var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-theme-provider',{attrs:{"dark":""}},[_c('base-section',{staticClass:"grey darken-4",attrs:{"id":"info"}},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"12"}},[_c('base-business-info')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }